import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'yz-file-carousel',
  templateUrl: './yz-file-carousel.component.html',
  styleUrls: ['./yz-file-carousel.component.less']
})
export class YzFileCarouselComponent implements OnInit {

  // 屏幕高度
  carouselHeight = window.innerHeight;

  // 当前展示图片索引
  carouselIndex = 0;

  // 图片集合（必须有url）
  fileList: Array<any> = [];

  constructor(
    public dialogRef: MatDialogRef<YzFileCarouselComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    console.log('file-carousel接收参数：');
    console.log(this.data);
    // 只能预览图片格式文件
    this.fileList = this.data.fileList;
    this.carouselIndex = this.data.index;
  }

  // 关闭预览
  closeFileCarousel() {
    this.dialogRef.close();
  }

}
